import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchFilterSubitems, fetchStageRowRecruiters } from "../../../../Redux/ActionCreators/candidateAction";
import { mapHiringStatusSubitems, mapRecruiters, mapStageStatusSubitems } from "./activityUtils";

const SUBITEM_LIMIT = 100;

// Sidebar options for the Activity-wise filters. Stage, Stage status and Hiring status
// come from the same advanced-filters subitems the Candidate-wise sidebar uses;
// Recruiter comes from stage-rows/recruiters. Each list is null while loading.
const useActivityFilterOptions = (jobId) => {
  const dispatch = useDispatch();
  const [options, setOptions] = useState({ stages: null, stageStatuses: null, hiringStatuses: null, recruiters: null });

  useEffect(() => {
    if (!jobId) return undefined;
    let alive = true;
    const merge = (patch) => alive && setOptions((prev) => ({ ...prev, ...patch }));

    dispatch(fetchFilterSubitems(jobId, "stage_statuses", { limit: SUBITEM_LIMIT, offset: 0 }))
      .then((res) => merge(mapStageStatusSubitems(res?.success ? res.data : null)));
    dispatch(fetchFilterSubitems(jobId, "hiring_status", { limit: SUBITEM_LIMIT, offset: 0 }))
      .then((res) => merge({ hiringStatuses: mapHiringStatusSubitems(res?.success ? res.data : null) }));
    dispatch(fetchStageRowRecruiters(jobId))
      .then((res) => merge({ recruiters: mapRecruiters(res?.recruiters || []) }));

    return () => { alive = false; };
  }, [dispatch, jobId]);

  return options;
};

export default useActivityFilterOptions;
